import { useNavigate, useParams } from "react-router-dom";
import { Form, FormikProvider, useFormik } from "formik";
import * as jnb from "react-bootstrap";
import { decode as base64_decode } from "base-64";
import { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { BsPrinter } from "react-icons/bs";

export default function PaymentSuccess() {
  const { id } = useParams();
  let responsestring = base64_decode(id);
  let responsevalues = responsestring.split("###");
  let parsedObject = JSON.parse(responsevalues[0]);
  const formIk = useFormik({});
  const navigate = useNavigate();


  useEffect(() => {
    if (id !== '' || id !== null || id !== undefined) {
      localStorage.setItem("hasReloaded", "true");
    }
  }, []);

  function backtoHome() {
    navigate("/dashboard");
  }
  let componentRef = useRef();
  const handleprint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "PaymentPrint",

  });
  return (
    <>
      <div className="main_section"></div>
      {parsedObject?.auth_status !== "0300" ? (<>
        <FormikProvider value={formIk}>
          <Form onChange={formIk.handleChange} onSubmit={formIk.handleSubmit}>
            <jnb.Container>
              <jnb.Row>
                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                  <div className="page-titlespacing inner-herbpage-service-title1">
                  </div>
                </jnb.Col>
              </jnb.Row>
            </jnb.Container>
            <jnb.Container className="page-titlespacing outer-page-content-container">
              <div className="jumbotron mt20 form-card-jnb" style={{ marginTop: "5px" }} >
                <jnb.Row>
                  <jnb.Col xs={12} sm={12} md={12} lg={9} xl={9} xxl={9}></jnb.Col>
                  <jnb.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}
                  >
                  </jnb.Col>
                </jnb.Row>

                <table border="1" width="100%" role="presentation">
                  <tbody>
                    <tr>
                      <td align="center">
                        <h4>
                          <label style={{ color: "red", fontSize: "1.5rem" }}>
                            <h4> Your Payment Was {parsedObject?.status} for <label style={{ color: "red", fontSize: "1.5rem" }}> Rs. {parsedObject?.charge_amount}/- </label> on {parsedObject?.message}</h4>
                          </label>
                        </h4>
                      </td>
                    </tr>

                    <tr>
                      <td align="center">
                        <a href="/payment">
                          <button type="button" className="btn btn-sm btn-secondary" > Back to Payment Page </button>
                        </a>

                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </jnb.Container>
          </Form>
        </FormikProvider>
      </>) :
        (<>
          <FormikProvider value={formIk}>
            <Form onChange={formIk.handleChange} onSubmit={formIk.handleSubmit}>
              <jnb.Container>
                <jnb.Row>
                  <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    <div className="page-titlespacing inner-herbpage-service-title1">
                    </div>
                  </jnb.Col>
                </jnb.Row>
              </jnb.Container>
              <br />
              <jnb.Container className="outer-page-content-container">
                <div className="jumbotr mt20 form-card-jnb pt-3" ref={componentRef}    >

                  <font color="green">
                    <center>
                      <h4> Your Payment Was {parsedObject?.status} for <label style={{ color: "red", fontSize: "1.5rem" }}> Rs. {parsedObject?.charge_amount}/- </label> on {parsedObject?.payment_date}</h4>
                      <h4> Your Transaction Id is :<label style={{ color: "orange", fontSize: "1.5rem" }}>{parsedObject?.trans_id}</label></h4>
                      <h4> Reference Id for your Application : <label style={{ color: "orange", fontSize: "1.5rem" }}>{parsedObject?.order_id}</label></h4>
                      <h4> Please save this Transaction Id/ Reference Id for future reference.  </h4>
                    </center>
                  </font>
                </div>

                <button type="button" className=" btn  btn-sm affl-print me-2" onClick={handleprint}><BsPrinter title="Print" size={"20px"} /> Print</button>

                <jnb.Row>
                  <jnb.Col xs={12} sm={12} md={12} lg={9} xl={9} xxl={9}></jnb.Col>
                  <jnb.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                    <button
                      type="button"
                      className="btn btn-sm btn-secondary"
                      style={{ float: "right" }}
                      onClick={() => {
                        backtoHome();
                      }}
                    >
                      Click here to Application
                    </button>
                  </jnb.Col>
                </jnb.Row>
              </jnb.Container>
            </Form>
          </FormikProvider>
        </>)}
    </>
  );
}
